export default __webpack_public_path__ + "static/media/photo--sm--misc-12.0f401b5a.jpg";